<template>
  <section class="n4-llamada" v-if="CTA?.Mostrar && CTA.Titulo?.Texto">
    <div class="n2-contenedor n4-llamada__caja n2-aparece">
      <h2>{{ CTA.Titulo.Texto }}</h2>
      <p v-if="CTA.Subtitulo?.Texto">{{ CTA.Subtitulo.Texto }}</p>
      <template v-if="CTA.Button?.Texto">
        <a v-if="externo" :href="CTA.Button.Url" target="_blank" rel="noopener" class="n2-boton n2-boton--acento n2-boton--grande">{{ CTA.Button.Texto }}</a>
        <NuxtLink v-else :to="CTA.Button.Url || getLocalePath('/contacto')" class="n2-boton n2-boton--acento n2-boton--grande">{{ CTA.Button.Texto }}</NuxtLink>
      </template>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { getLocalePath } = useUtils()
// Panel: Inicio → Llamada a la acción
const CTA = computed(() => NOTARIA.value?.Theme?.Home?.CallToAction)
const externo = computed(() => /^https?:\/\//i.test(CTA.value?.Button?.Url || ''))
</script>
